import { render, staticRenderFns } from "./CosechaNew2.vue?vue&type=template&id=3b2fb672"
import script from "./CosechaNew2.vue?vue&type=script&lang=js"
export * from "./CosechaNew2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports